import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import {TypesHeading,BlessingContainer} from '../../styles/styled/tagsStyled';

const BlessHeroes = () => (
    <BlessingContainer>
        <TypesHeading colored>Coming Soon!</TypesHeading>
        <br/>
        <TypesHeading subText>We’ve got some great ideas, but we want to hear yours too!</TypesHeading>
        <TypesHeading subText>You can leave your thoughts, ideas and feedback on the</TypesHeading>
        <TypesHeading colored>
        <a href= "https://ideas.blessourheroes.org/" rel="noopener noreferrer" target="_blank">
            #BlessOurHeroes feedback page   &nbsp;<FontAwesomeIcon icon={faExternalLink}/>
        </a>
        </TypesHeading>
    </BlessingContainer>
);

export default BlessHeroes;
